import { modalSelectedColor } from "../../lib/Color";

type Props = {
    extensionId?: number;
    isModeSelected: boolean;
    onClick: () => void;
}

const SettingConfirmExtensionArea = ({ extensionId, isModeSelected, onClick }: Props) => {
    const makeBackgroundColor = () => {
        return isModeSelected ? modalSelectedColor : "initial"
    }

    return (
        <>
            {
                extensionId ? <img
                    src={"https://d2fvodbijouf8s.cloudfront.net/images/extensions/64/" + extensionId + ".png"
                    }
                    style={{
                        width: 64,
                        height: 64,
                        backgroundColor: makeBackgroundColor(),
                        paddingTop: "4px",
                        paddingBottom: "4px",
                    }
                    }
                    onClick={onClick}
                /> : <div
                    style={{
                        width: 64,
                        height: 64,
                        backgroundColor: makeBackgroundColor(),
                        paddingTop: "4px",
                        paddingBottom: "4px",
                    }}
                    onClick={onClick}
                >
                </div >}
        </>
    );
}

export default SettingConfirmExtensionArea;